export const authRoles = {
  Admin: ['Admin'],
  Dealer: ['Admin', 'Dealer'],
  Teacher: ['Admin', 'Dealer', 'Teacher'],
  //Guest: ['Admin', 'Dealer', 'Teacher', 'Guest'],
}
